import { toRaw } from 'vue';
import { FormValidator, type FormValidatorConfig, type FormValidatorContext, type FormValidatorSettings } from '../models';
import { isEmpty } from '../utils';

export interface DateIsAfterValidatorSettings extends FormValidatorSettings {
  dateToCompare: Date | null;
  allowEqual: boolean;
  otherFieldName: string;
}

export type DateIsAfterValidatorConfig = FormValidatorConfig<DateIsAfterValidatorSettings>;

export class DateIsAfterValidator extends FormValidator<DateIsAfterValidatorSettings> {
  constructor() {
    super();
    this._name = 'dateIsAfter';
    this._settings = {
      invalidMessage: 'form.validator.dateIsAfter.invalidMessage',
      needTranslate: true,
      dateToCompare: null,
      allowEqual: true,
      otherFieldName: ''
    };
  }

  public override async onValidate(value: any, context: FormValidatorContext) {
    if (isEmpty(value)) {
      this.reset();
      return;
    }

    const values = toRaw(context.values);

    const compareDate = this.settings.dateToCompare ? this.settings.dateToCompare : new Date(values[this.settings.otherFieldName]);

    const dateValue = new Date(value);
    this._valid = this.settings.allowEqual ? dateValue >= compareDate : value > compareDate;

    if (!this._valid) {
      this.addMessage(this.settings.invalidMessage, 'error', { dateToCompare: compareDate.toLocaleDateString() });
    }
  }
}
